import 'bootstrap/dist/css/bootstrap.min.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import React from 'react'
import AppRoutes from '@routes'
import { GraphqlProvider, ErrorTrackingAPI, PubSubInitializer } from '@services'
import { ConfirmDialogProvider, OrderEventProvider } from '@context'

ErrorTrackingAPI.initialize()

export default function App() {
    return (
        <ConfirmDialogProvider>
            <OrderEventProvider>
                <GraphqlProvider>
                    <PubSubInitializer>
                        <AppRoutes />
                    </PubSubInitializer>
                </GraphqlProvider>
            </OrderEventProvider>
        </ConfirmDialogProvider>
    )
}
